// https://jwt.io/
// https://jwt.io/#debugger
// https://jwt.io/libraries?language=JavaScript

const jwt = require('jsonwebtoken');

/**
 * 
 * @param { string } issuer 签发者
 * @param { string } screct 密钥
 * @returns 
 */
export const generateJWT = (issuer, screct)=> {
  // 将nbf调小的 原因是 在 PC中浏览器打开正常，但是在手机移动端，会出现 “nbf: token not valid yet”错误， 及 nbf > 服务器时间
  // 与网关约定好，将nbf的时间调小5分钟（预留参数，网关侧没做校验）
  const beginTime = Math.floor(Date.now() / 1000) - (5 * 60)  
  const expiresTime = Math.floor(Date.now() / 1000) + (2 * 60) // 过期时间

  const token = jwt.sign({ 
    iss: issuer, // jwt签发者
    nbf: beginTime, // 定义在什么时间之前，该jwt都是不可用的.；
    exp: expiresTime // jwt的过期时间，这个过期时间必须要大于签发时间
  }, screct ) // 根据screct + base64(header) + base64(payload) 加密算法生成签名
  
  return `Bearer ${token}`
}
